import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getStoreDetail,
  getStoreTimes,
  updateStoreTimes,
} from "../../redux/actions/storeActions";
import DefaultLayout from "../../layouts/DefaultLayout";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import { baseURLFile } from "../../constants";
import { toast } from "react-toastify";

function StoreTimeScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  //
  //   #     (0, "Monday"),
  const [startMonday, setStartMonday] = useState("");
  const [startMondayError, setStartMondayError] = useState("");

  const [endMonday, setEndMonday] = useState("");
  const [endMondayError, setEndMondayError] = useState("");

  const [isMondayClosed, setIsMondayClosed] = useState(true);
  //   #     (1, "Tuesday"),
  const [startTuesday, setStartTuesday] = useState("");
  const [startTuesdayError, setStartTuesdayError] = useState("");

  const [endTuesday, setEndTuesday] = useState("");
  const [endTuesdayError, setEndTuesdayError] = useState("");

  const [isTuesdayClosed, setIsTuesdayClosed] = useState(true);
  //   #     (2, "Wednesday"),
  const [startWednesday, setStartWednesday] = useState("");
  const [startWednesdayError, setStartWednesdayError] = useState("");

  const [endWednesday, setEndWednesday] = useState("");
  const [endWednesdayError, setEndWednesdayError] = useState("");

  const [isWednesdayClosed, setIsWednesdayClosed] = useState(true);
  //   #     (3, "Thursday"),
  const [startThursday, setStartThursday] = useState("");
  const [startThursdayError, setStartThursdayError] = useState("");

  const [endThursday, setEndThursday] = useState("");
  const [endThursdayError, setEndThursdayError] = useState("");

  const [isThursdayClosed, setIsThursdayClosed] = useState(true);
  //   #     (4, "Friday"),
  const [startFriday, setStartFriday] = useState("");
  const [startFridayError, setStartFridayError] = useState("");

  const [endFriday, setEndFriday] = useState("");
  const [endFridayError, setEndFridayError] = useState("");

  const [isFridayClosed, setIsFridayClosed] = useState(true);
  //   #     (5, "Saturday"),
  const [startSaturday, setStartSaturday] = useState("");
  const [startSaturdayError, setStartSaturdayError] = useState("");

  const [endSaturday, setEndSaturday] = useState("");
  const [endSaturdayError, setEndSaturdayError] = useState("");

  const [isSaturdayClosed, setIsSaturdayClosed] = useState(true);
  //   #     (6, "Sunday"),
  const [startSunday, setStartSunday] = useState("");
  const [startSundayError, setStartSundayError] = useState("");

  const [endSunday, setEndSunday] = useState("");
  const [endSundayError, setEndSundayError] = useState("");

  const [isSundayClosed, setIsSundayClosed] = useState(true);

  //
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const storeDetail = useSelector((state) => state.detailStore);
  const { loadingStoreInfo, errorStoreInfo, successStoreInfo, storeInfo } =
    storeDetail;

  const storeTime = useSelector((state) => state.getListTimesStore);
  const { loadingTimesStore, errorTimesStore, storeTimes } = storeTime;

  const storeUpdateTimes = useSelector((state) => state.updateStoreTimes);
  const {
    loadingStoreUpdateTime,
    errorStoreUpdateTime,
    successStoreUpdateTime,
  } = storeUpdateTimes;

  const redirect = "/";
  useEffect(() => {
    const fetchData = async () => {
      if (!userInfo) {
        navigate(redirect);
      } else {
        // await dispatch(getListStoresUsers("0"));
        await dispatch(getStoreTimes(id));
        await dispatch(getStoreDetail(id));
      }
    };

    fetchData();
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (storeInfo && storeInfo !== null && storeInfo !== undefined) {
      for (let index = 0; index < storeTimes?.length; index++) {
        const element = storeTimes[index];

        //         #     (0, "Monday"),
        if (element.name_day === "Monday") {
          if (element.is_closed) {
            setIsMondayClosed(true);
            setStartMonday("");
            setEndMonday("");
          } else {
            setIsMondayClosed(false);
            setStartMonday(element.time_start ?? "");
            setEndMonday(element.time_end ?? "");
          }
        }
        // #     (1, "Tuesday"),
        else if (element.name_day === "Tuesday") {
          if (element.is_closed) {
            setIsTuesdayClosed(true);
            setStartTuesday("");
            setEndTuesday("");
          } else {
            setIsTuesdayClosed(false);
            setStartTuesday(element.time_start ?? "");
            setEndTuesday(element.time_end ?? "");
          }
        }
        // #     (2, "Wednesday"),
        else if (element.name_day === "Wednesday") {
          if (element.is_closed) {
            setIsWednesdayClosed(true);
            setStartWednesday("");
            setEndWednesday("");
          } else {
            setIsWednesdayClosed(false);
            setStartWednesday(element.time_start ?? "");
            setEndWednesday(element.time_end ?? "");
          }
        }
        // #     (3, "Thursday"),
        else if (element.name_day === "Thursday") {
          if (element.is_closed) {
            setIsThursdayClosed(true);
            setStartThursday("");
            setEndThursday("");
          } else {
            setIsThursdayClosed(false);
            setStartThursday(element.time_start ?? "");
            setEndThursday(element.time_end ?? "");
          }
        }
        // #     (4, "Friday"),
        else if (element.name_day === "Friday") {
          if (element.is_closed) {
            setIsFridayClosed(true);
            setStartFriday("");
            setEndFriday("");
          } else {
            setIsFridayClosed(false);
            setStartFriday(element.time_start ?? "");
            setEndFriday(element.time_end ?? "");
          }
        }
        // #     (5, "Saturday"),
        else if (element.name_day === "Saturday") {
          if (element.is_closed) {
            setIsSaturdayClosed(true);
            setStartSaturday("");
            setEndSaturday("");
          } else {
            setIsSaturdayClosed(false);
            setStartSaturday(element.time_start ?? "");
            setEndSaturday(element.time_end ?? "");
          }
        }
        // #     (6, "Sunday"),
        else if (element.name_day === "Sunday") {
          if (element.is_closed) {
            setIsSundayClosed(true);
            setStartSunday("");
            setEndSunday("");
          } else {
            setIsSundayClosed(false);
            setStartSunday(element.time_start ?? "");
            setEndSunday(element.time_end ?? "");
          }
        }
      }
    }
  }, [storeInfo]);
  return (
    <DefaultLayout>
      <div className="animate-fadeIn">
        {/* Modern Breadcrumb */}
        <nav className="flex mb-6" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <a
                href="/dashboard"
                className="inline-flex items-center text-sm font-medium text-primary hover:text-secondary transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  ></path>
                </svg>
                Dashboard
              </a>
            </li>
            <li>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <a
                  href="/stores"
                  className="ml-1 text-sm font-medium text-primary hover:text-secondary md:ml-2 transition-colors duration-200"
                >
                  Stores
                </a>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="ml-1 text-sm font-medium text-secondary md:ml-2">
                  Store Hours
                </span>
              </div>
            </li>
          </ol>
        </nav>

        {/* Header with Store Image */}
        <div
          className="relative mb-8 rounded-xl overflow-hidden bg-gradient-to-r from-primary to-secondary shadow-lg"
          style={{
            backgroundImage: "url('/assets/background-auth-screen.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-secondary/80"></div>
          <div className="relative z-10 px-6 py-8 md:px-10 md:py-12">
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Store Hours
            </h1>
            <p className="text-white/80 max-w-xl">
              Configure your store's business hours to let customers know when you're open for orders.
            </p>
          </div>
        </div>

        {loadingStoreInfo ? (
            <Loader />
          ) : errorStoreInfo ? (
            <Alert message={errorStoreInfo} />
          ) : storeInfo ? (
            <div>
              {/* info store */}
              <div className="relative mb-10 group">
                {/* Decorative elements */}
                <div className="absolute -top-4 -left-4 w-24 h-24 bg-primary/5 rounded-full blur-xl group-hover:bg-primary/10 transition-all duration-700"></div>
                <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary/5 rounded-full blur-xl group-hover:bg-primary/10 transition-all duration-700"></div>

                {/* Main card */}
                <div className="relative bg-white rounded-2xl shadow-sm overflow-hidden group-hover:shadow-xl transition-all duration-500 border border-gray-100">
                  <div className="absolute h-1 top-0 left-0 right-0 bg-gradient-to-r from-primary via-primary-light to-primary-dark"></div>

                  <div className="p-6 sm:p-8">
                    <div className="flex flex-col md:flex-row gap-6 items-start">
                      {/* Store logo section */}
                      <div className="relative flex-shrink-0">
                        <div className="relative">
                          <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden bg-gray-100 border-4 border-white shadow-lg group-hover:shadow-xl transition-all duration-500">
                            <img
                              src={baseURLFile + storeInfo.store_logo}
                              className="w-full h-full object-cover"
                              alt={storeInfo.store_name}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src =
                                  "https://via.placeholder.com/150?text=No+Image";
                              }}
                            />
                          </div>

                          {/* Status indicator */}
                          <div className="absolute -bottom-3 -right-3 bg-white p-1.5 rounded-full shadow-md">
                            <div className="bg-green-500 text-white p-1.5 rounded-full flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Store info section */}
                      <div className="flex-1 space-y-4">
                        <div>
                          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                            <h2 className="text-2xl font-bold text-gray-900">
                              {storeInfo.store_name || "---"}
                            </h2>

                            <div className="flex items-center gap-2">
                              <div className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-semibold bg-primary/10 text-primary">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3.5 w-3.5 mr-1"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                {storeInfo.store_type === "RESTAURANT"
                                  ? "Restaurant"
                                  : storeInfo.store_type === "GROCERIES"
                                  ? "Grocery Store"
                                  : storeInfo.store_type || "---"}
                              </div>
                            </div>
                          </div>

                          <div className="mt-1 flex flex-wrap gap-3">
                            <div className="flex items-center text-sm text-gray-500">
                              <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 mr-2 flex-shrink-0">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3.5 w-3.5 text-gray-500"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="truncate max-w-xs">
                                {storeInfo.store_address ||
                                  "No address available"}
                              </span>
                            </div>

                            {storeInfo.store_phone && (
                              <div className="flex items-center text-sm text-gray-500">
                                <div className="flex items-center justify-center w-6 h-6 rounded-full bg-gray-100 mr-2 flex-shrink-0">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-3.5 w-3.5 text-gray-500"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                  </svg>
                                </div>
                                <span>{storeInfo.store_phone}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="pt-3 border-t border-gray-100">
                          <div className="flex flex-wrap gap-2">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 mr-1"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              Configure Business Hours
                            </span>
                            <a
                              href={`/stores/edit/${id}`}
                              className="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium bg-gray-100 text-gray-700 hover:bg-gray-200 transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 mr-1"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                              </svg>
                              Edit Store
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end info store */}

              {/*  */}
              <div className="relative mb-8">
                {/* Background decorative elements */}
                <div className="absolute -top-6 -right-6 w-32 h-32 bg-primary/5 rounded-full blur-xl"></div>
                <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-blue-50 rounded-full blur-xl"></div>

                {/* Main content container */}
                <div className="relative bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100">
                  {/* Decorative top bar */}
                  <div className="absolute top-0 inset-x-0 h-1.5 bg-gradient-to-r from-primary via-blue-500 to-primary-dark"></div>
                  {/* Header section */}
                  <div className="p-6 sm:p-8">
                    <div className="flex flex-col space-y-6">
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                        <div className="flex items-start md:items-center gap-4">
                          <div className="relative">
                            <div className="absolute inset-0 bg-primary/20 rounded-full blur-sm"></div>
                            <div className="relative flex-shrink-0 bg-primary/10 p-3.5 rounded-full">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-7 w-7 text-primary"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-1">
                              Business Hours
                            </h3>
                            <p className="text-gray-500">
                              Set when your store is open to receive orders
                            </p>
                          </div>
                        </div>
                        {/*  */}
                        <div className="flex items-center gap-3">
                          <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full text-blue-700 text-sm font-medium">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 mr-2 text-blue-500"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                clipRule="evenodd"
                              />
                            </svg>
                            Toggle days to mark as closed
                          </div>
                        </div>
                      </div>
                      {/*  */}
                      <div className="border-t border-gray-100 pt-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                          {/* Monday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isMondayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isMondayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isMondayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isMondayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isMondayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Monday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isMondayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isMondayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="monday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isMondayClosed}
                                      onChange={() =>
                                        setIsMondayClosed(!isMondayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isMondayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isMondayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isMondayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isMondayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                            {/* Time inputs section */}
                            <div
                              className={`p-5 ${
                                isMondayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isMondayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startMondayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isMondayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startMondayError
                                          ? "focus:ring-red-200"
                                          : isMondayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isMondayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startMonday}
                                      onChange={(e) =>
                                        setStartMonday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startMondayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startMondayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isMondayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endMondayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isMondayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endMondayError
                                          ? "focus:ring-red-200"
                                          : isMondayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isMondayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endMonday}
                                      onChange={(e) =>
                                        setEndMonday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endMondayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endMondayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/*  */}
                          </div>
                          {/* End Monday */}
                          {/* Tuesday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isTuesdayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isTuesdayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isTuesdayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isTuesdayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isTuesdayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Tuesday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isTuesdayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isTuesdayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="tuesday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isTuesdayClosed}
                                      onChange={() =>
                                        setIsTuesdayClosed(!isTuesdayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isTuesdayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isTuesdayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isTuesdayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isTuesdayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isTuesdayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isTuesdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startTuesdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isTuesdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startTuesdayError
                                          ? "focus:ring-red-200"
                                          : isTuesdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isTuesdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startTuesday}
                                      onChange={(e) =>
                                        setStartTuesday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startTuesdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startTuesdayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isTuesdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endTuesdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isTuesdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endTuesdayError
                                          ? "focus:ring-red-200"
                                          : isTuesdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isTuesdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endTuesday}
                                      onChange={(e) =>
                                        setEndTuesday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endTuesdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endTuesdayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Tuesday */}

                          {/* Wednesday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isWednesdayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isWednesdayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isWednesdayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isWednesdayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isWednesdayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Wednesday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isWednesdayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isWednesdayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="wednesday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isWednesdayClosed}
                                      onChange={() =>
                                        setIsWednesdayClosed(!isWednesdayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isWednesdayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isWednesdayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isWednesdayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isWednesdayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isWednesdayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isWednesdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startWednesdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isWednesdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startWednesdayError
                                          ? "focus:ring-red-200"
                                          : isWednesdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isWednesdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startWednesday}
                                      onChange={(e) =>
                                        setStartWednesday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startWednesdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startWednesdayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isWednesdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endWednesdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isWednesdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endWednesdayError
                                          ? "focus:ring-red-200"
                                          : isWednesdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isWednesdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endWednesday}
                                      onChange={(e) =>
                                        setEndWednesday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endWednesdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endWednesdayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Wednesday */}
                          {/* Thursday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isThursdayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isThursdayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isThursdayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isThursdayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isThursdayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Thursday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isThursdayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isThursdayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="thursday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isThursdayClosed}
                                      onChange={() =>
                                        setIsThursdayClosed(!isThursdayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isThursdayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isThursdayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isThursdayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isThursdayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isThursdayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isThursdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startThursdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isThursdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startThursdayError
                                          ? "focus:ring-red-200"
                                          : isThursdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isThursdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startThursday}
                                      onChange={(e) =>
                                        setStartThursday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startThursdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startThursdayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isThursdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endThursdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isThursdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endThursdayError
                                          ? "focus:ring-red-200"
                                          : isThursdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isThursdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endThursday}
                                      onChange={(e) =>
                                        setEndThursday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endThursdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endThursdayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Thursday */}
                          {/* Friday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isFridayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isFridayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isFridayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isFridayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isFridayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Friday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isFridayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isFridayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="friday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isFridayClosed}
                                      onChange={() =>
                                        setIsFridayClosed(!isFridayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isFridayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isFridayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isFridayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isFridayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isFridayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isFridayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startFridayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isFridayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startFridayError
                                          ? "focus:ring-red-200"
                                          : isFridayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isFridayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startFriday}
                                      onChange={(e) =>
                                        setStartFriday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startFridayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startFridayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isFridayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endFridayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isFridayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endFridayError
                                          ? "focus:ring-red-200"
                                          : isFridayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isFridayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endFriday}
                                      onChange={(e) =>
                                        setEndFriday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endFridayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endFridayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Friday */}
                          {/* Saturday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isSaturdayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isSaturdayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isSaturdayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isSaturdayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isSaturdayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Saturday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isSaturdayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isSaturdayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="saturday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isSaturdayClosed}
                                      onChange={() =>
                                        setIsSaturdayClosed(!isSaturdayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isSaturdayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isSaturdayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isSaturdayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isSaturdayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isSaturdayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isSaturdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startSaturdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isSaturdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startSaturdayError
                                          ? "focus:ring-red-200"
                                          : isSaturdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isSaturdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startSaturday}
                                      onChange={(e) =>
                                        setStartSaturday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startSaturdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startSaturdayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isSaturdayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endSaturdayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isSaturdayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endSaturdayError
                                          ? "focus:ring-red-200"
                                          : isSaturdayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isSaturdayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endSaturday}
                                      onChange={(e) =>
                                        setEndSaturday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endSaturdayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endSaturdayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* End Saturday */}
                          {/* Sunday */}
                          <div
                            className={`group relative bg-whiter rounded-xl overflow-hidden transition-all duration-500 ${
                              isSundayClosed
                                ? "shadow-md border-2 border-red-300"
                                : "shadow-md hover:shadow-xl border-2 border-primary"
                            }`}
                          >
                            {/* Status indicator dot */}
                            <div className="absolute top-3 right-3 z-10">
                              <span className="flex h-3 w-3 relative">
                                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${isSundayClosed ? 'bg-red-400' : 'bg-primary'} opacity-75`}></span>
                                <span className={`relative inline-flex rounded-full h-3 w-3 ${isSundayClosed ? 'bg-red-500' : 'bg-primary'}`}></span>
                              </span>
                            </div>

                            {/* Card header with day name and toggle */}
                            <div
                              className={`px-5 py-4 ${
                                isSundayClosed
                                  ? "bg-gradient-to-r from-red-100 to-red-50"
                                  : "bg-gradient-to-r from-gray-3 to-gray-2"
                              } transition-colors duration-500`}
                            >
                              <div className="flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                  <div
                                    className={`flex-shrink-0 p-2.5 rounded-lg ${
                                      isSundayClosed
                                        ? "bg-red-200 text-red-700 shadow-sm shadow-red-200/50"
                                        : "bg-primary/20 text-primary shadow-sm shadow-primary/20"
                                    } transition-all duration-500 font-bold`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                  <div>
                                    <h4 className="font-bold text-black">
                                      Sunday
                                    </h4>
                                    <p
                                      className={`text-xs font-semibold ${
                                        isSundayClosed
                                          ? "text-red-700"
                                          : "text-primary"
                                      } transition-colors duration-500`}
                                    >
                                      {isSundayClosed
                                        ? "Currently closed"
                                        : "Open for business"}
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="inline-flex items-center cursor-pointer">
                                    <input
                                      id="sunday-closed"
                                      type="checkbox"
                                      className="sr-only"
                                      checked={isSundayClosed}
                                      onChange={() =>
                                        setIsSundayClosed(!isSundayClosed)
                                      }
                                    />
                                    <div
                                      className={`relative w-14 h-7 transition-all duration-300 ease-in-out rounded-full ${
                                        isSundayClosed
                                          ? "bg-gradient-to-r from-red-400 to-red-500 shadow-inner shadow-red-600/20"
                                          : "bg-gradient-to-r from-primary/70 to-primary shadow-inner shadow-primary/20"
                                      }`}
                                    >
                                      <div
                                        className={`absolute left-1 top-1 bg-white w-5 h-5 rounded-full shadow-md transition-all duration-300 ease-in-out transform ${
                                          isSundayClosed ? "" : "translate-x-7"
                                        } flex items-center justify-center overflow-hidden`}
                                      >
                                        <span className={`absolute inset-0 flex items-center justify-center text-[8px] font-extrabold ${
                                          isSundayClosed ? "text-red-600" : "text-primary"
                                        }`}>
                                          {isSundayClosed ? "OFF" : "ON"}
                                        </span>
                                      </div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div
                              className={`p-5 ${
                                isSundayClosed ? "opacity-50" : ""
                              }`}
                            >
                              <div className="space-y-4">
                                {/* Opening time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Opening Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        From
                                      </span>
                                    </div>
                                    <input
                                      disabled={isSundayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        startSundayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isSundayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        startSundayError
                                          ? "focus:ring-red-200"
                                          : isSundayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isSundayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={startSunday}
                                      onChange={(e) =>
                                        setStartSunday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {startSundayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {startSundayError}
                                    </p>
                                  )}
                                </div>

                                {/* Closing time */}
                                <div>
                                  <label className="flex items-center text-sm font-medium text-body mb-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-4 w-4 mr-1.5 text-bodydark"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Closing Time{" "}
                                    <span className="text-red-500 ml-1">*</span>
                                  </label>
                                  <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                      <span className="text-bodydark text-sm">
                                        Until
                                      </span>
                                    </div>
                                    <input
                                      disabled={isSundayClosed}
                                      type="time"
                                      className={`w-full pl-14 pr-4 py-3 border-2 ${
                                        endSundayError
                                          ? "border-red-300 bg-red-50/50 focus:border-red-500"
                                          : isSundayClosed
                                            ? "border-stroke focus:border-bodydark bg-gray-3"
                                            : "border-primary/30 focus:border-primary bg-primary/5"
                                      } rounded-lg focus:outline-none focus:ring-2 ${
                                        endSundayError
                                          ? "focus:ring-red-200"
                                          : isSundayClosed
                                            ? "focus:ring-bodydark/20"
                                            : "focus:ring-primary/20"
                                      } text-sm transition-all duration-200 ${
                                        isSundayClosed ? "text-bodydark" : "text-black font-medium"
                                      }`}
                                      value={endSunday}
                                      onChange={(e) =>
                                        setEndSunday(e.target.value)
                                      }
                                    />
                                  </div>
                                  {endSundayError && (
                                    <p className="mt-1.5 text-xs text-red-500 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5 mr-1"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                      {endSundayError}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* End Sunday */}
                        </div>
                        {/* operations */}
                        <div className="mt-10 pt-6 border-t border-gray-100">
                          <div className="flex flex-col-reverse sm:flex-row items-center justify-between gap-4">
                            <div className="w-full sm:w-auto">
                              <a
                                href="/stores"
                                className="group flex items-center justify-center w-full px-6 py-3 border-2 border-gray-200 rounded-xl text-gray-600 font-medium hover:bg-gray-50 hover:border-gray-300 transition-all duration-300 text-center"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5 mr-2 text-gray-400 group-hover:text-gray-600 transition-colors duration-300"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                Back to Stores
                              </a>
                            </div>

                            <div className="w-full sm:w-auto">
                              <button
                                disabled={loadingStoreUpdateTime}
                                onClick={async () => {
                                  var check = true;
                                  // Reset all error states
                                  setStartMondayError("");
                                  setEndMondayError("");
                                  setStartTuesdayError("");
                                  setEndTuesdayError("");
                                  setStartWednesdayError("");
                                  setEndWednesdayError("");
                                  setStartThursdayError("");
                                  setEndThursdayError("");
                                  setStartFridayError("");
                                  setEndFridayError("");
                                  setStartSaturdayError("");
                                  setEndSaturdayError("");
                                  setStartSundayError("");
                                  setEndSundayError("");

                                  // Validate Monday
                                  if (isMondayClosed === false) {
                                    if (startMonday === "") {
                                      setStartMondayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endMonday === "") {
                                      setEndMondayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Tuesday
                                  if (isTuesdayClosed === false) {
                                    if (startTuesday === "") {
                                      setStartTuesdayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endTuesday === "") {
                                      setEndTuesdayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Wednesday
                                  if (isWednesdayClosed === false) {
                                    if (startWednesday === "") {
                                      setStartWednesdayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endWednesday === "") {
                                      setEndWednesdayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Thursday
                                  if (isThursdayClosed === false) {
                                    if (startThursday === "") {
                                      setStartThursdayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endThursday === "") {
                                      setEndThursdayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Friday
                                  if (isFridayClosed === false) {
                                    if (startFriday === "") {
                                      setStartFridayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endFriday === "") {
                                      setEndFridayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Saturday
                                  if (isSaturdayClosed === false) {
                                    if (startSaturday === "") {
                                      setStartSaturdayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endSaturday === "") {
                                      setEndSaturdayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  // Validate Sunday
                                  if (isSundayClosed === false) {
                                    if (startSunday === "") {
                                      setStartSundayError(
                                        "Opening time is required"
                                      );
                                      check = false;
                                    }
                                    if (endSunday === "") {
                                      setEndSundayError(
                                        "Closing time is required"
                                      );
                                      check = false;
                                    }
                                  }

                                  if (check) {
                                    await dispatch(
                                      updateStoreTimes(id, {
                                        // Monday
                                        is_monday: isMondayClosed
                                          ? "True"
                                          : "False",
                                        start_monday: isMondayClosed
                                          ? ""
                                          : startMonday,
                                        end_monday: isMondayClosed
                                          ? ""
                                          : endMonday,
                                        // Tuesday
                                        is_tuesday: isTuesdayClosed
                                          ? "True"
                                          : "False",
                                        start_tuesday: isTuesdayClosed
                                          ? ""
                                          : startTuesday,
                                        end_tuesday: isTuesdayClosed
                                          ? ""
                                          : endTuesday,
                                        // Wednesday
                                        is_wednesday: isWednesdayClosed
                                          ? "True"
                                          : "False",
                                        start_wednesday: isWednesdayClosed
                                          ? ""
                                          : startWednesday,
                                        end_wednesday: isWednesdayClosed
                                          ? ""
                                          : endWednesday,
                                        // Thursday
                                        is_thursday: isThursdayClosed
                                          ? "True"
                                          : "False",
                                        start_thursday: isThursdayClosed
                                          ? ""
                                          : startThursday,
                                        end_thursday: isThursdayClosed
                                          ? ""
                                          : endThursday,
                                        // Friday
                                        is_friday: isFridayClosed
                                          ? "True"
                                          : "False",
                                        start_friday: isFridayClosed
                                          ? ""
                                          : startFriday,
                                        end_friday: isFridayClosed
                                          ? ""
                                          : endFriday,
                                        // Saturday
                                        is_saturday: isSaturdayClosed
                                          ? "True"
                                          : "False",
                                        start_saturday: isSaturdayClosed
                                          ? ""
                                          : startSaturday,
                                        end_saturday: isSaturdayClosed
                                          ? ""
                                          : endSaturday,
                                        // Sunday
                                        is_sunday: isSundayClosed
                                          ? "True"
                                          : "False",
                                        start_sunday: isSundayClosed
                                          ? ""
                                          : startSunday,
                                        end_sunday: isSundayClosed
                                          ? ""
                                          : endSunday,
                                      })
                                    );
                                  } else {
                                    toast.error(
                                      "Please fill in all required fields for open days"
                                    );
                                  }
                                }}
                                className={`w-full flex items-center justify-center px-8 py-3 rounded-xl font-medium text-white shadow-lg transition-all duration-300 ${
                                  loadingStoreUpdateTime
                                    ? "bg-primary/80 cursor-not-allowed"
                                    : "bg-primary hover:bg-primary-dark hover:shadow-xl"
                                }`}
                              >
                                {loadingStoreUpdateTime ? (
                                  <>
                                    <svg
                                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                      ></path>
                                    </svg>
                                    Updating Store Hours...
                                  </>
                                ) : (
                                  <>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5 mr-2"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Save Store Hours
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* End Operation */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      
    </DefaultLayout>
  );
}

export default StoreTimeScreen;
